import BTCDialog from "./BTCDialog";
import newmorecurrency from "./newmorecurrency";
import nodeDetails from "./nodeDetail/nodeDetails";
import tradingStatistics from "./nodeDetail/tradingStatistics";
import tradingOpponent from "./nodeDetail/tradingOpponent";
import transactionAnalysis from "./nodeDetail/transactionAnalysis";
import transactionDetails from "./nodeDetail/transactionDetails";
import nodeDetailValue from "./nodeDetail/nodeDetailValue";
import assetTable from "./nodeDetail/assetTable";
import firstCurryInflow from "./nodeDetail/firstCurryInflow";
import otherInfo from "./nodeDetail/otherInfo";
import surveydetail from "./nodeDetail/surveydetail";
import surveyuserinfo from "./nodeDetail/surveyuserinfo";
import userbehavior from "./nodeDetail/userbehavior";
import otctable from "./nodeDetail/otctable";
import legaltender from "./nodeDetail/legaltender";
import virtualcoin from "./nodeDetail/virtualcoin";
import otctransactiondetails from "./nodeDetail/otctransactiondetails";
import chargeTrading from "./nodeDetail/chargeTrading";
import walletBalance from "./nodeDetail/walletBalance";
import loginDevice from "./nodeDetail/loginDevice";
import paymentRecord from "./nodeDetail/paymentRecord";
import downloadPage from "./nodeDetail/downloadPage";
import takeOver from "./nodeDetail/takeOver";
import edgeDetail from "./edgeDetail/edgeDetail";
import leftMenuAimodel from "./leftMenu/aimodel";
import canvasHistory from "./leftMenu/canvasHistory";
import surveyadvice from "./leftMenu/surveyadvice";
import leftMenu from "./leftMenu/leftMenu";
import rightMenu from "./rightMenu/rightMenu";
import addcasedatadailog from "./rightMenu/addcasedatadailog";
import bottomMenu from "./bottomMenu/bottomMenu";
import shortcutKeys from "./bottomMenu/shortcutKeys";
import singleCanvas from "./singleCanvas/index.js";
import newCanvasComponents from "./newCanvasComponents/index.js";
import share from "./share/index.js";
import morecurrency from "./morecurrency/index.js";

export default {
  BTCDialog,
  newmorecurrency,
  nodeDetails,
  tradingStatistics,
  tradingOpponent,
  transactionAnalysis,
  transactionDetails,
  nodeDetailValue,
  assetTable,
  firstCurryInflow,
  otherInfo,
  surveydetail,
  surveyuserinfo,
  userbehavior,
  otctable,
  legaltender,
  virtualcoin,
  otctransactiondetails,
  chargeTrading,
  walletBalance,
  loginDevice,
  paymentRecord,
  downloadPage,
  takeOver,
  edgeDetail,
  leftMenu: {
    aimodel: leftMenuAimodel,
    ...leftMenu,
  },
  canvasHistory: {
    ...canvasHistory,
    surveyadvice,
  },
  rightMenu,
  addcasedatadailog,
  bottomMenu,
  shortcutKeys,
  singleCanvas,
  newCanvasComponents,
  share,
  morecurrency,
};
